<script>
	import saveSvg from "save-svg-as-png";
	let width = 400;
	let height = 400;
	let gridWidth = 40;
	let gridHeight = 40;
	let strokeWidth = 1;

	function save() {
		saveSvg.saveSvgAsPng(document.getElementById("grid"), "grid.png");
	}
</script>

<div class="row">
	<div class="col-sm-10">
		<form>
			<fieldset>
				<div class="row">
					<div class="col-sm-2">
						<label for="width">Width</label>
					</div>
					<div class="col-sm-3">
						<input id="width" type="number" bind:value={width} />
					</div>
					<div class="col-sm-2">
						<label for="height">Height</label>
					</div>
					<div class="col-sm-3">
						<input id="height" type="number" bind:value={height} />
					</div>
				</div>
				<div class="row">
					<div class="col-sm-2">
						<label for="gridWidth">Grid block width</label>
					</div>
					<div class="col-sm-3">
						<input id="gridWidth" type="number" bind:value={gridWidth} />
					</div>
					<div class="col-sm-2">
						<label for="gridHeight">Grid block height</label>
					</div>
					<div class="col-sm-3">
						<input id="gridHeight" type="number" bind:value={gridHeight} />
					</div>
				</div>
				<div class="row">
					<div class="col-sm-2">
						<label for="strokeWidth">Line width</label>
					</div>
					<div class="col-sm-3">
						<input id="strokeWidth" type="number" bind:value={strokeWidth} />
					</div>
					<button class="primary" on:click={save}>Download</button><br />
				</div>
			</fieldset>
		</form>
	</div>
	<div class="col-sm-2">
	</div>
</div>
<div class="row">
	<svg id="grid" width="{width}" height="{height}">
		{#each Array(Math.floor(1 + width/gridWidth) || []) as _, i}
			<line x1="{i * gridWidth}" y1="{0}" x2="{i * gridWidth}" y2="{height}" style="stroke:rgb(0,0,0);stroke-width:{strokeWidth}" />
		{/each}

		{#each Array(Math.floor(1 + height/gridHeight) || []) as _, i}
			<line x1="0" y1="{i*gridHeight}" x2="{width}" y2="{i*gridHeight}" style="stroke:rgb(0,0,0);stroke-width:{strokeWidth}" />
		{/each}

	</svg>
</div>
